import {
  SET_BANGO,
  CLEAR_SHEER_ID,
  CLEAR_INTEGRATIONS,
  SET_INITIAL_SHEER_STEP,
  SET_REDIRECT_URL,
  SET_SHEER_PROGRAM,
  SET_SHEER_VERIFICATION_ID,
} from '../Types';

const initialState = {
  bango: {
    subscriptionId: '',
    redirectUrl: '',
    productId: '',
  },
  sheerId: {
    verificationId: '',
    program: '', //military or firstResponder
    step: '',
  },
};

export const integrations = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BANGO:
      return { ...state, bango: payload };
    case SET_INITIAL_SHEER_STEP:
      return { ...state, sheerId: { ...state.sheerId, step: payload } };
    case SET_REDIRECT_URL:
      return { ...state, bango: { ...state.bango, redirectUrl: payload } };
    case SET_SHEER_VERIFICATION_ID:
      return { ...state, sheerId: { ...state.sheerId, verificationId: payload } };
    case SET_SHEER_PROGRAM:
      return { ...state, sheerId: { ...state.sheerId, program: payload } };
    case CLEAR_SHEER_ID:
      return { ...state, sheerId: initialState.sheerId };
    case CLEAR_INTEGRATIONS:
      return { ...state, ...initialState };
    default:
      return state;
  }
};
